'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { FaFacebook } from 'react-icons/fa';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

function shareOnFacebook(url: string) {
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  window.open(facebookShareUrl, 'facebook-share-dialog', 'width=626,height=436');
}

interface BlogShareProps {
  blog: Blog;
}

export function BlogShare({ blog }: BlogShareProps) {
  const { t } = useTranslations();
  return (
    <div className={cn('custom-section', 'ea-section__xl-b')}>
      <Button
        className="w-full rounded-full sm:w-fit"
        onClick={() => shareOnFacebook(`${window.location.origin}/blog/${blog.slug}`)}
        aria-label="Zdieľať článok na Facebooku"
      >
        <FaFacebook size={24} className="mr-2" /> {t('text1155')}
      </Button>
    </div>
  );
}
